module.exports = require("npm:debug@2.2.0/browser.js");